<template>
  <v-main class="background fill-height">
    <v-row
      class="d-flex fill-height"
      no-gutters
    >
      <v-col
        cols="12"
        class="align-center d-flex"
      >
        <v-container>
          <div class="pa-7 pa-sm-12">
            <v-row>
              <v-col
                class="mx-auto"
                cols="12"
                lg="6"
              >
                <v-card
                  class="mx-auto rounded-lg"
                  style="max-width: 400px; z-index: 1"
                >
                  <div v-if="ecoMemberParty">
                    <v-img
                      src="https://equitycorps.org/wp-content/uploads/2024/04/ECO-Logo-Horizontal-Full-Color_high-res.png"
                    />
                    <v-img
                      src="https://images.pexels.com/photos/2387532/pexels-photo-2387532.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                      height="200px"
                      dark
                      gradient="to top right, rgba(19,50,58,.98), rgba(19,50,58,.81)"
                    >
                      <v-row class="fill-height">
                        <v-card-title class="white--text ma-auto">
                          <div class="text-center">
                            <CheckMarkIcon class="mx-auto mb-4 d-inline" />
                            <h6 class="text-h6">
                              ECO MEMBER
                            </h6>
                          </div>
                        </v-card-title>
                      </v-row>
                    </v-img>
                    <v-list two-line>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon color="indigo">
                            mdi-id-card
                          </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title>{{ ecoMemberParty.id }}</v-list-item-title>
                          <v-list-item-subtitle>Member ID</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider inset />
                    </v-list>
                    <v-list>
                      <h4 class="pl-4">
                        This Member has the following benefits:
                      </h4>
                      <v-list-item
                        v-for="(benefit, index) of benefits"
                        :key="index"
                      >
                        <v-list-item-avatar>
                          <v-icon color="success">
                            mdi-check
                          </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title>{{ benefit }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                  <div
                    v-else
                    class="text-center pa-4"
                  >
                    <ErrorIcon
                      class="mx-auto mb-4 red--text"
                      width="52"
                    />
                    <h4>
                      Unknown ECO Member
                    </h4>
                    This member does not seem to exist. If you believe this is an error please contact the ECO call center at 1-888-274-7292.
                  </div>
                  <div
                    v-if="isLoadingScreenVisible"
                    key="loading-screen"
                    class="align-center d-flex flex-column"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="64"
                    />

                    <div class="my-4">
                      Loading, please wait ...
                    </div>
                  </div>
                </v-card>
                <p class="text-center mt-2 text-caption">
                  For more information, contact Clearinghouse@equitycorps.org
                </p>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'

import CheckMarkIcon from '@/components/Icons/CheckMark'
import ErrorIcon from '@/components/Icons/ErrorIcon'

export default {
  name: 'ECOMemberProfile',

  components: {
    CheckMarkIcon,
    ErrorIcon,
  },

  props: {
    partyId: {
      type: String,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      benefits: [
        'Free Access to all registered Panel Attorneys; including consultations from a panel attorney. Pre-authorization required for pre-engagement consultations.',
        'Free Access to all ECO Legal Clinics, ECO Mobile Clinics, and ECO Contracted Legal Clinics',
        'Financial support for filing fees, transportation to / from official appointments, forensic evaluations, and expert witness supports.',
        'Free Access to educational programming.',
      ],

      ecoMemberParty: null,
      requestLoading: false,
    }
  },

  computed: {
    isLoadingScreenVisible () {
      return this.requestLoading
    },

    ...mapGetters([
      'isLoggedIn',
    ]),
  },

  async created () {
    if (this.isLoggedIn) this.loggedInPartyProfile()
    else this.fetchPartyPublicView()
  },

  methods: {
    fetchPartyPublicView () {
      this.requestLoading = true
      this.getPartyPublicView(
        this.partyId
      ).
        then(data => {
          this.ecoMemberParty = data
          this.displayAlert('success', 'Successfully loaded Profile')
        }).
        catch(error => {
          this.displayAlert('error', error.data.message)
        }).
        finally(_ => { this.requestLoading = false })
    },

    loggedInPartyProfile () {
      const uri = `/party/${this.partyId}/edit/personal-details`
      this.$router.push(uri)
    },

    ...mapActions(PARTY_NAMESPACE, [
      'getPartyPublicView',
    ]),
  },
}
</script>

<style scoped>
/deep/ .v-list-item__title, .v-list-item__subtitle {
    overflow: visible;
    text-overflow: unset;
    white-space: normal;
}
</style>
